import { useMemo } from "react";
import "./maximetroMax.css";

function formatNumber(value, decimals = 1) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return Number(num.toFixed(decimals));
}

function formatDateAR(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";

  return new Intl.DateTimeFormat("es-AR", {
    timeZone: "America/Argentina/Buenos_Aires",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).format(d);
}

export default function MaximetroMax({ data }) {
  const maximetroData = useMemo(() => {
    if (!data) return null;
    return data;
  }, [data]);

  if (!maximetroData) return null;

  const topIntervals = maximetroData.audit?.top_intervals || [];
  const quality = maximetroData.quality;
  const overall = maximetroData.result?.overall;
  const byTou = maximetroData.result?.by_tou || {};
  const billableBands = maximetroData.config?.billable_band_codes || [];

  return (
    <div className="mxAuditCard">
      <div className="mxAuditHeader">
        <div className="mxAuditTitle">Resumen Maxímetro</div>

        <div className="mxSummaryRow">
          {billableBands.map((code) => {
            const band = byTou[code];
            if (!band) return null;

            return (
              <div key={code} className="mxSummaryCard facturable">
                <div className="mxSummaryBand">{code}</div>

                <div className="mxSummaryMain">
                  <span className="mxKW">
                    {formatNumber(band.measured_max_demand, 1)} kW
                  </span>
                  <span className="mxKWH">
                    {formatNumber(band.interval_energy, 3)} kWh
                  </span>
                </div>

                <div className="mxSummaryDate">
                  {formatDateAR(band.timestamp_of_max_utc)}
                </div>
              </div>
            );
          })}

          {overall && (
            <div className="mxSummaryCard general">
              <div className="mxSummaryBand">GENERAL</div>

              <div className="mxSummaryMain">
                <span className="mxKW">
                  {formatNumber(overall.measured_max_demand, 1)} kW
                </span>
                <span className="mxKWH">
                  {formatNumber(overall.interval_energy, 3)} kWh
                </span>
              </div>

              <div className="mxSummaryDate">
                {formatDateAR(overall.timestamp_of_max_utc)}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mxAuditTableWrap">
        <div className="mxAuditSubTitle">
          Top {topIntervals.length} intervalos de mayor demanda
        </div>

        {topIntervals.length === 0 ? (
          <div className="mxAuditEmpty">
            No hay datos de auditoría disponibles.
          </div>
        ) : (
          <table className="mxAuditTable">
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha / Hora</th>
                <th>Demanda (kW)</th>
                <th>Energía (kWh)</th>
              </tr>
            </thead>
            <tbody>
              {topIntervals.map((interval, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{formatDateAR(interval.timestamp_utc)}</td>
                  <td>{formatNumber(interval.demand, 1)}</td>
                  <td>{formatNumber(interval.energy, 3)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {quality && (
        <div className="mxAuditQuality">
          <div>Intervalos esperados: {quality.expected_intervals}</div>
          <div>Recibidos: {quality.received_intervals}</div>
          <div>
            Faltantes: {quality.missing_intervals} (
            {(quality.missing_ratio * 100).toFixed(2)}%)
          </div>
          <div
            className={`mxAuditStatus ${
              quality.status === "INVALID"
                ? "statusInvalid"
                : quality.status === "OK_WITH_GAPS"
                ? "statusWarning"
                : "statusOk"
            }`}
          >
            Estado: {quality.status}
          </div>
        </div>
      )}
    </div>
  );
}